import { useStore } from 'effector-react'

import {
  $internalTransfers,
  internalTransfersListMounted,
  getInternalTransfers,
  $totalCountOfInternalTransfers,
} from './model'
import { WithdrawalRequest } from '../../withdrawals/list/types'
import { InternalTransfersRequest } from './types'

export const useInternalTransfersList = () => {
  const onChangeInternalTransfersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: InternalTransfersRequest) => {
    internalTransfersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const loading = useStore(getInternalTransfers.pending)

  const internalTransfers = useStore($internalTransfers)
  const totalCountOfInternalTransfers = useStore($totalCountOfInternalTransfers)
  return {
    internalTransfers,
    loading,
    totalCountOfInternalTransfers,
    onChangeInternalTransfersList,
  }
}
